import { jsx as n, Fragment as A, jsxs as f } from "react/jsx-runtime";
import { withManagedProps as s } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as r } from "@made-people/react-prop-guard";
import { motion as d, AnimatePresence as P } from "motion/react";
import { AnimatedLoaderIcon as T } from "@made-people/blueprint-icons";
import { buttonBlueprint as h } from "./index-blueprint.es.js";
import z, { useEffect as C } from "react";
import E from "react-confetti-explosion";
import { useTranslate as Y } from "@made-people/grease-translations";
import b from "clsx";
import { useLink as W } from "@made-people/grease-link";
import "@made-people/blueprint";
const $ = () => /* @__PURE__ */ n(
  d.svg,
  {
    viewBox: "0 0 44 44",
    width: "30px",
    height: "30px",
    display: "block",
    "z-index": "1",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: "1",
    initial: {
      opacity: 0,
      pathLength: 1,
      strokeDashoffset: 124.6,
      strokeDasharray: "0, 162.6, 30, 132.6"
    },
    animate: {
      opacity: 1,
      pathLength: 1,
      strokeDashoffset: 162.6,
      strokeDasharray: "0, 162.6, 28, 134.6"
    },
    transition: {
      delay: 0.3,
      type: "tween",
      duration: 0.3
    },
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M14,24 L21,31 L39.7428882,11.5937758 C35.2809627,6.53125861 30.0333333,4 24,4 C12.95,4 4,12.95 4,24 C4,35.05 12.95,44 24,44 C35.05,44 44,35.05 44,24 C44,19.3 42.5809627,15.1645919 39.7428882,11.5937758",
        transform: "translate(-2.000000, -2.000000)"
      }
    )
  }
), L = t.object({
  confetti: t.boolean().optional()
}), M = s(
  "Confetti",
  r(L, ({ confetti: e }) => {
    const [a, i] = z.useState(!1);
    return C(() => {
      if (e) {
        const o = setTimeout(() => {
          i(!0);
        }, 100);
        return () => clearTimeout(o);
      }
    }, [e]), C(() => {
      if (a) {
        const o = setTimeout(() => {
          i(!1);
        }, 5e3);
        return () => clearTimeout(o);
      }
    }, [a]), /* @__PURE__ */ n(A, { children: a && /* @__PURE__ */ n(
      "div",
      {
        style: {
          position: "absolute",
          left: "0px",
          top: "0px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: /* @__PURE__ */ n(
          E,
          {
            force: 0.2,
            duration: 3500,
            particleCount: 80,
            width: 400,
            particleSize: 4
          }
        )
      }
    ) });
  })
), p = t.object({
  /**
   * The styles object.
   */
  variants: t.custom().optional(),
  /**
   * The button label.
   */
  label: t.custom().optional(),
  /**
   * Optional icon (left).
   */
  iconLeft: t.custom().optional(),
  /**
   * Optional icon (right).
   */
  iconRight: t.custom().optional(),
  /**
   * Replaces the button label with an icon illustrating progress.
   */
  progress: t.enum(["default", "loading", "complete"]).optional(),
  iconLoading: t.custom().optional(),
  iconComplete: t.custom().optional(),
  /**
   * Optional Framer Motion animation config for when the progress icon animates in.
   */
  animateProgressIconIn: t.custom().optional(),
  /**
   * Optional Framer Motion animation config for when the progress icon animates out.
   */
  animateProgressIconOut: t.custom().optional(),
  /**
   * Optional On Click handler that all button types can use.
   */
  onClick: t.function().args(
    t.custom().optional()
  ).returns(t.union([t.void(), t.promise(t.unknown())])).optional(),
  "aria-disabled": t.enum(["true", "false"]).optional(),
  isSelected: t.boolean().optional(),
  dataAttr: t.record(t.union([t.string(), t.number(), t.boolean()])).optional(),
  // enables passing arbitrary data attributes for styling purposes
  disabled: t.boolean().optional(),
  className: t.string().optional(),
  id: t.string().optional(),
  confetti: L.shape.confetti,
  hoverEffect: t.union([t.enum(["spin"]), t.literal(!1)]).optional()
  // when a specific hover effect requires markup changes
}), y = s(
  "ButtonContent",
  r(
    {
      schema: p,
      defaultProps: {
        progress: "default",
        animateProgressIconIn: {
          initial: !1,
          animate: { opacity: 1, translateY: "0%" },
          exit: { opacity: 0, translateY: "-100%" },
          transition: { duration: 0.4, ease: "anticipate" }
        },
        animateProgressIconOut: {
          initial: { opacity: 1, translateY: "0%" },
          animate: { opacity: 0, translateY: "100%" },
          exit: { opacity: 1, translateY: "0%" },
          transition: { duration: 0.4, ease: "anticipate" }
        },
        iconComplete: /* @__PURE__ */ n($, {}),
        iconLoading: /* @__PURE__ */ n(T, {}),
        hoverEffect: !1
      }
    },
    ({
      label: e,
      iconLeft: a,
      iconRight: i,
      progress: o,
      variants: l,
      confetti: m,
      animateProgressIconIn: c,
      animateProgressIconOut: w,
      iconComplete: N,
      iconLoading: S,
      hoverEffect: x
    }) => {
      const u = h.styles(l), I = Y(), D = typeof e == "string" ? I(e) : e, g = /* @__PURE__ */ f(
        d.div,
        {
          ...o !== "default" ? w : c,
          className: b(u.labelWrapper),
          children: [
            a && /* @__PURE__ */ n("span", { className: u.iconLeft, children: a }),
            e && /* @__PURE__ */ n("span", { className: u.label, children: D }),
            i && /* @__PURE__ */ n("span", { className: u.iconRight, children: i })
          ]
        }
      );
      return /* @__PURE__ */ f(A, { children: [
        /* @__PURE__ */ n(M, { confetti: m }),
        x === "spin" && /* @__PURE__ */ f("div", { className: "flex flex-col h-full group-hover/button:-translate-y-full transition-transform ease-[cubic-bezier(.23,1,.32,1)] duration-500", children: [
          g,
          g
        ] }),
        !x && g,
        /* @__PURE__ */ n(P, { initial: !1, children: o !== "default" && /* @__PURE__ */ f(
          d.span,
          {
            ...c,
            className: u.progressIcon,
            children: [
              o === "complete" && N,
              o === "loading" && S
            ]
          }
        ) })
      ] });
    }
  )
), k = (e) => e ? Object.entries(e).reduce(
  (a, [i, o]) => {
    const l = i.startsWith("data-") ? i : `data-${i}`;
    return a[l] = String(o), a;
  },
  {}
) : {}, B = p.merge(
  t.object({
    link: t.object({
      target: t.string().optional(),
      href: t.string().optional(),
      anchor: t.string().optional(),
      onClick: t.function().args(t.custom()).returns(t.void()).optional()
    }).optional(),
    context: t.custom().optional(),
    title: t.string().optional()
  })
), O = s(
  "ButtonAsLink",
  r(B, (e) => {
    var m, c;
    const a = W(), i = h.styles(e.variants), o = k(e.dataAttr), l = e.link ? `${e.link.href ?? ""}${e.link.anchor ? `#${e.link.anchor}` : ""}` : "";
    return /* @__PURE__ */ n(
      a,
      {
        id: e.id,
        className: b(i.wrapper, e.className),
        href: l,
        title: e.title,
        target: (m = e.link) == null ? void 0 : m.target,
        "aria-disabled": e.disabled ? "true" : "false",
        ...o,
        onClick: (c = e.link) == null ? void 0 : c.onClick,
        context: e.context,
        children: /* @__PURE__ */ n(y, { ...e })
      }
    );
  })
), v = p.merge(
  t.object({
    type: t.enum(["button", "submit", "reset"]).optional(),
    ariaLabel: t.string().optional()
  })
), R = s(
  "ButtonAsButton",
  r(v, (e) => {
    const a = h.styles(e.variants), i = k(e.dataAttr);
    return /* @__PURE__ */ n(
      "button",
      {
        id: e.id,
        className: b(a.wrapper, e.className),
        "data-is-selected": e.isSelected,
        onClick: e.onClick,
        disabled: !!e.disabled,
        "aria-disabled": e.disabled ? "true" : "false",
        type: e.type,
        "aria-label": e.ariaLabel,
        ...i,
        children: /* @__PURE__ */ n(y, { ...e })
      }
    );
  })
), j = p.merge(
  t.object({
    title: t.string().optional()
  })
), F = s(
  "ButtonAsSpan",
  r(j, (e) => {
    const a = h.styles(e.variants), i = k(e.dataAttr);
    return /* @__PURE__ */ n(
      "span",
      {
        id: e.id,
        className: b(a.wrapper, e.className),
        title: e.title,
        "aria-disabled": e.disabled ? "true" : "false",
        ...i,
        children: /* @__PURE__ */ n(y, { ...e })
      }
    );
  })
), K = t.discriminatedUnion("as", [
  v.merge(t.object({ as: t.literal("button") })),
  B.merge(t.object({ as: t.literal("a") })),
  j.merge(t.object({ as: t.literal("span") }))
]), U = s(
  "Button",
  r(K, (e) => e.as === "a" ? /* @__PURE__ */ n(O, { ...e }) : e.as === "button" ? /* @__PURE__ */ n(R, { ...e }) : e.as === "span" ? /* @__PURE__ */ n(F, { ...e }) : null)
);
U.displayName = "Button";
const it = () => /* @__PURE__ */ n(
  d.svg,
  {
    viewBox: "25 25 50 50",
    width: "24px",
    height: "24px",
    display: "block",
    "z-index": "1",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    opacity: "0",
    animate: {
      opacity: 1
    },
    transition: {
      duration: 0.5,
      ease: "easeIn"
    },
    children: /* @__PURE__ */ n(
      d.circle,
      {
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeDasharray: "1, 200",
        strokeDashoffset: "0",
        animate: {
          strokeDasharray: ["1 200", "89 200", "89 200"],
          rotate: 360,
          strokeDashoffset: [0, -35, -124]
        },
        transition: {
          type: "tween",
          ease: "linear",
          duration: 1.3,
          repeat: 1 / 0,
          repeatType: "loop"
        }
      }
    )
  }
);
export {
  U as Button,
  R as ButtonAsButton,
  O as ButtonAsLink,
  F as ButtonAsSpan,
  y as ButtonContent,
  M as Confetti,
  $ as IconCheckAnimated,
  it as IconLoaderAnimated,
  v as buttonAsButtonSchema,
  B as buttonAsLinkSchema,
  j as buttonAsSpanSchema,
  p as buttonContentPropsSchema,
  K as buttonSchema,
  L as confettiSchema,
  k as transformDataAttributes
};
//# sourceMappingURL=index.es.js.map
